import React, { useState, useEffect, useMemo } from "react";
import GeneralAuthentication from "../general/GeneralAuthentication";
import * as customTheme from "../theme";
import { makeStyles, ThemeProvider, createTheme } from "@material-ui/core/styles";
import { FormControlLabel, Typography, Box, Grid, InputAdornment, List, ListItem, ListItemText, IconButton, Paper, Container, Button, TextField, Checkbox, Badge, Switch, Avatar, Menu, MenuItem } from "@material-ui/core";
import translations from "../utils/translations";
import ActionMessageButton from "../general/ActionMessageButton";
import Autocomplete from "@material-ui/lab/Autocomplete";
import quoteyBot from "../logos/common/quotey-homepage-bot.svg";
import quoteyText from "../logos/common/quotey-text.svg";
import homepageBackground from "../logos/common/homepage-background.png"
import { getVerticalList, loadverticals } from "../store/verticals";
import { useDispatch, useSelector } from "react-redux";
import { createProspectByCallingAPI, getProspectIdJustCreated } from "../store/operations";
import { 	getMyCustomers, getCustomersTable, setFirstPage, getisFirstPage } from "../store/mycustomers";
import {Settings as SettingsIcon, Save as SaveIcon, AddCircleOutline as AddCircleOutlineIcon, NotificationImportantRounded as NotificationIcon, Search as SearchIcon  } from '@material-ui/icons';
import { useNavigate } from "react-router-dom";
import {	getAutoreminderState, reminderModalSet } from "../store/components";
import { brokerLoggedOut, getBrokerInformation, updateBrokerLanguagePreference, getBrokerStats, updateBrokerProfile } from "../store/broker";
import { AddReminderPopUp, ReminderPopOver } from "./ReminderModal";
import {	updateUserLanguagePreference, updateLanguagePreference } from "../store/userManagement";
import { getProductList, loadProducts } from "../store/products";
import { loadBrokerageInsurers, getInsurersList } from "../store/insurers";
import { OrangeButton } from "../general/OrangeButton";
import Spinner from "react-bootstrap/Spinner";
// Reusable Components
const ApplicationHeader = ({ fontStyle, title, classes }) => (
	<Grid container alignItems="center" className={classes.titleContainer}>
		<Grid item xs={1}>
			{quoteyBot ? (
				<img src={quoteyBot} className="quotey-bot" alt="quoteyrobo" style={{'scale':'3',}} />
			) : (
				<div>Image not found</div>
			)}
		</Grid>
		<Grid item xs={10}>
			<div style={{ ...fontStyle,  }}>
				{/* ...classes.welcomeTitle */}
				{title}
			</div>
		</Grid>
	</Grid>
);

const NavigationButtons = ({ onPrev, onNext, nextLabel, classes, disabledNext=false, languagecode='en', showSpinner=false }) => (
	<Box className={classes.navButtonContainer}>
		<Button variant="contained" className={classes.navButton} onClick={onPrev}>
			{language[languagecode].nav_prev}
		</Button>
		<Button variant="contained" className={classes.navButton} onClick={onNext} disabled={disabledNext}>
			<Spinner
				style={{ display: showSpinner ? 'block' : 'none', marginRight:"10px" }}
				animation="border"
				size="sm"
				variant="light"
			/>
			{nextLabel ? nextLabel : language[languagecode].nav_next }
		</Button>
	</Box>
);

const HelpSidebar = ({ title, helpItems, classes }) => (
	<Grid item xs={4}>
		<Paper className={classes.sidebar}>
			<Typography variant="h5" style={{'paddingLeft':'16px', 'fontFamily': 'GibsonSemiBd'}}>{title}</Typography>
			<List>
				{helpItems.map((item, index) => (
					<ListItem key={index}>
						<ListItemText primary={item.primary} secondary={item.secondary} className={classes.listItemText} />
					</ListItem>
				))}
			</List>
		</Paper>
	</Grid>
);

const InsurerHelpSideBar = ({ title, helpItems, ignoreInsurer, setignoreInsurer } ) => {
	const useStyles = makeStyles((theme) => ({
		sidebar: {
			padding: '16px',
			backgroundColor: "#D6DAE7",
			minHeight: "70vh",
			maxHeight: "75vh",
			overflowY:"auto",
			height: '100%',
		},
		gridContainer: {
			maxHeight: '95%',
			overflowY: 'auto',
		},
		listItemText: {
			'& .MuiTypography-root': {
				fontSize: '0.9rem',
			},
		},
		image: {
			width: '75%',
			maxWidth: '180px',
			height: 'auto',
			marginRight: theme.spacing(1),
		},
		itemContainer: {
			display: 'flex',
			alignItems: 'center',
			padding: theme.spacing(1),
		},
	}));
	const classes = useStyles();
	const midPoint = Math.ceil(helpItems.length / 2);
  const leftColumn = helpItems.slice(0, midPoint);
  const rightColumn = helpItems.slice(midPoint);
	const handleCheckboxChange = (item) => (event) => {
		 const isChecked = event.target.checked;
		 if(!isChecked){
			setignoreInsurer((prev) => [...prev, item.code])
		 }else {
			setignoreInsurer((prev) => prev.filter((x) => x != item.code )  )
		 }
	}

	return (
    <Grid item xs={4}>
      <Paper className={classes.sidebar}>
        <Typography variant="h5" style={{ paddingLeft: '16px', fontFamily: 'GibsonSemiBd' }}>
          {title}
        </Typography>
        <Grid container className={classes.gridContainer}>
          <Grid item xs={6}>
            {leftColumn.map((item, index) => (
              <Box key={index} className={classes.itemContainer}>
                <img src={item.imageUrl} alt={item.label} className={classes.image} />
                <FormControlLabel
                  control={
										<Checkbox
											color="primary"
											checked={!ignoreInsurer.includes(item.code)}
											onChange={handleCheckboxChange(item)}
										/>}
                  label={item.label}
                  className={classes.listItemText}
                />
              </Box>
            ))}
          </Grid>
          <Grid item xs={6}>
            {rightColumn.map((item, index) => (
              <Box key={index + midPoint} className={classes.itemContainer}>
                <img src={item.imageUrl} alt={item.label} className={classes.image} />
                <FormControlLabel
                  control={
										<Checkbox
											color="primary" 
											checked={!ignoreInsurer.includes(item.code)}
											onChange={handleCheckboxChange(item)}
										/>}
                  label={item.label}
                  className={classes.listItemText}
                />
              </Box>
            ))}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}

const CoverageToggle = ({ label, selectedOption, setSelectedOption, code, disabled , languagecode}) => {
	const classes = useStyles();
	const questionText = `${language[languagecode].last_q_options_1} <span class="${classes.bold}">${label}</span> ${language[languagecode].last_q_options_2}`
	return (
		<Box className={classes.questionBlock}>
			<Typography variant="body1" className={classes.questionText} dangerouslySetInnerHTML={{ __html: questionText }} />
			<Box className={classes.buttonGroup}>
				{['Package', 'Stand-alone'].map((option) => (
					<Button
						key={option}
					 
						onClick={() => setSelectedOption((obj) => ({
							...obj,
							[code]: option,
						}))}
						className={`${classes.toggleButton} ${selectedOption === option ? classes.selected : ''}`}
						variant="contained"
					>
						{option}
					</Button>
				))}
			</Box>
		</Box>
	);
};

const calculatePackageDetails = ({ coverageToggles, setProduct, setSelected, setCoverageQuestions, setCoverageQuestionsStandAlone, setCoverageQuestionsPackage, type, productList, industryId } ) => {
		let newProduct = null;
		const newCoverageQuestions = [];
		const newCoverageQuestionsStandAlone = [];
		const newCoveragePackages = [];
		if(!Array.isArray(coverageToggles)) return;
		if (coverageToggles.length === 1) {
			newProduct = coverageToggles[0].code;
			newCoveragePackages.push(coverageToggles[0])
			// switch (coverageToggles[0].code) {
			// 	case "GeneralLiability":
			// 		newProduct = "General Liability";
			// 		break;
			// 	case "Residential":
			// 		newProduct = "Commercial Package";
			// 		break;
			// 	case "Property":
			// 		newProduct = "Commercial Property";
			// 		break;
			// 	case "ProfessionalLiability":
			// 		newProduct = "Professional Liability";
			// 		break;
			// 	case "CYBER":
			// 		newProduct = "CYBER";
			// 		break;
			// 	case "ManagementLiability":
			// 		newProduct = "D&O";
			// 		break;
			// 	case "LEGAL EXPENSE":
			// 		newProduct = "LEGAL EXPENSE";
			// 		break;
			// 	case "FLEET":
			// 		newProduct = "Auto Fleet";
			// 		break;
			// 	case "CARGO":
			// 		newProduct = "CARGO";
			// 		break;
			// 	default:
			// 		newProduct = coverageToggles[0].code;
			// 		break;
			// }
		} else {
			const coverageCodes = coverageToggles.map((x) => x.code);
			let foundCoverage = null;
			//console.log(productList.filter(x => x.package != undefined).map(x => x.code) );
			// use product list to get all codes that have package types
			const possibleTriageQuestionCodes = productList.filter(x => x.package != undefined).map(x => x.code)

			if (coverageCodes.includes("ProfessionalLiability")) {
				newProduct = "ProfessionalLiability";
				foundCoverage = coverageToggles.find(x => x.code == 'ProfessionalLiability');
				newCoveragePackages.push(foundCoverage)
				if(coverageCodes.includes("Property")){
					foundCoverage = coverageToggles.find(x => x.code == 'Property');
					newCoveragePackages.push(foundCoverage);
					newProduct = "Professional Package"
				}
			}
			else if ( ["GeneralLiability", "Property"].every((value) => coverageCodes.includes(value)) ) {
				newProduct = "Commercial Package";
				foundCoverage = coverageToggles.find(x => x.code == 'GeneralLiability');
				newCoveragePackages.push(foundCoverage)
				foundCoverage = coverageToggles.find(x => x.code == 'Property');
				newCoveragePackages.push(foundCoverage)

			} else if (coverageCodes.includes("GeneralLiability")) {
				newProduct = "GeneralLiability";
				foundCoverage = coverageToggles.find(x => x.code == 'GeneralLiability');
				newCoveragePackages.push(foundCoverage)
			} 
			const possiblePackage = ["GeneralLiability","ProfessionalLiability" ].some(value => coverageCodes.includes(value) );
			for( const coverage of coverageToggles){
				if( ["GeneralLiability", "Property", "ProfessionalLiability"].includes(coverage.code) ) continue;
				else if(coverage.packageonly?.includes(industryId)){
					console.log("Package only!!");
					newCoveragePackages.push(coverage)
				}
				else if(!coverage.package){
					newCoverageQuestionsStandAlone.push(coverage);
				}
				else if (coverage.package){
					const allOperations = coverage.package.flatMap(p => p.operationlist ?? []);
					const targetArray = possiblePackage && allOperations.includes(industryId) ? newCoverageQuestions : newCoverageQuestionsStandAlone;
					targetArray.push(coverage);
				}
			}
			if(!newProduct && newCoverageQuestionsStandAlone.length > 0){
				newProduct = newCoverageQuestionsStandAlone[0].code;
			}
		}
		// Update state
		setProduct(newProduct);
		setCoverageQuestions(newCoverageQuestions);
		setCoverageQuestionsStandAlone(newCoverageQuestionsStandAlone);
		setCoverageQuestionsPackage(newCoveragePackages)
		// console.log(
		// 	`newCoverageQuestions `, newCoverageQuestions,
		// 	`newCoverageQuestionsStandAlone `, newCoverageQuestionsStandAlone,
		// 	`newCoveragePackages`, newCoveragePackages
		// )
		// Update selected for stand-alone coverages
		setSelected((prev) => ({
			...(type === 'coverage' ? {} : prev),
			...Object.fromEntries(newCoverageQuestionsStandAlone.map((coverage) => [coverage.code, "Stand-alone"])),
			...Object.fromEntries(newCoveragePackages.map((coverage) => [coverage.code, "Package"])),
		}));
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		gap: theme.spacing(2),
		padding: theme.spacing(2),
	},
	container: {
		// backgroundColor: '#f5f8fa',
		padding: theme.spacing(3),
		// backgroundImage: `url(${homepageBackground})`, // Add background image
		backgroundSize: '100% 100%', // Adjusts image to cover the container
		backgroundPosition: 'center', // Centers the image
		backgroundRepeat: 'no-repeat', // Prevents image repetition
		minHeight: '100vh', // Full viewport height
    width: '100vw', // Full viewport width
    position: 'relative', // Required for the pseudo-element overlay
    margin: 0, // Remove default margins
    boxSizing: 'border-box', // Ensure padding doesn't affect size
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			// backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white overlay
			zIndex: 1, // Place the overlay above the background image
		},
		'& > *': {
			position: 'relative',
			zIndex: 2, // Ensure content is above the overlay
		},
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		margin: "12px 12px 2px 14px",
	},
	logo: {
		height: '5vh',
		width: "19vw",
		transform: "scale(4.1)",
	},
	botImage: {
		height: '12vh',
		marginRight: '24px',
	},
	titleContainer: {
		// marginBottom: theme.spacing(4),
		marginLeft:"4vw",
		display: "flex",
		justifyContent: "space-between",
		marginTop: "12vh",
		marginBottom:"6vh",
		[theme.breakpoints.down('lg')]: {
    	marginTop: "2vh", // Collapse on small screens
  	},
	},
	welcomeTitle: {
		fontSize: '2.5rem',
	},
	subtitle: {
		fontFamily: "GibsonSemiBd",
		fontSize: "1.5vw",
		color: customTheme.COLORS.primary_navyblue,
	},
	description: {
		fontFamily: "GibsonRegular",
		color: "gray",
		fontSize: '1.02vw', // Larger description
		marginBottom: theme.spacing(4),
	},
	toggleContiner: {
		gap: theme.spacing(2),
		display: "flex",
	},
	toggleButton: {
		borderRadius: 8,
		border: '1px solid #1976d2',
		color: '#1976d2',
		width:"7.5vw",
		height:"5vh",
		backgroundColor: '#fff',
		minWidth: 120,
		textTransform: 'none',
		whiteSpace: 'normal', // Allow text to wrap
  	wordWrap: 'break-word', // Break long words if needed
  	padding: theme.spacing(1, 2), // Add padding for better text spacing
		'&:hover': {
			backgroundColor: '#e3f2fd',
		},
	},
	largeToggleButton: {
		borderRadius: 12,
		minHeight: "6vw",
		minWidth: "10vw",
		fontSize: 'clamp(0.8rem, 1.8vw, 1.1rem)', // Responsive font size
	},
	autocompleteContainer: {
    width: '100%',
    maxWidth: '500px', // Larger max-width for the autocomplete
  },
	largeTextField: {
    '& .MuiInputBase-input': {
      fontSize: '1.5rem', // Larger font size
      padding: theme.spacing(1.5, 2), // Increased padding
    },
  },
	selected: {
		backgroundColor: '#1976d2',
		color: '#fff',
		'&:hover': {
			backgroundColor: '#1565c0',
		},
	},
	sidebar: {
		padding: '16px',
		backgroundColor: "#D6DAE7",
		minHeight: "70vh",
		maxHeight: "75vh",
		overflowY:"auto"
	},
	contentGrid: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '89vh',
		margin: '0 auto',
	},
	questionBlock: {
		marginBottom: theme.spacing(4),
		display: "flex",
		justifyContent: "space-between",
	},
	questionArea: {
		marginLeft:"4vw",
		fontSize:"15px",
		minHeight:"4vh",
	},
	questionText: {
		marginBottom: theme.spacing(1),
		color: '#333',
		fontSize:"1.4rem"
	},
	bold: {
		fontWeight: 600,
	},
	buttonGroup: {
		display: 'flex',
		gap: theme.spacing(1.5),
	},
	navButtonContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginLeft: "4vw"
	},
	 navButton: {
		backgroundColor: '#1976d2',
		padding: '14px 28px', // Increased padding for larger buttons
		fontSize: '1.1rem',   // Larger text size
		minWidth: '130px',    // Minimum width for consistent size
		minHeight: '53px',    // Minimum height for larger buttons
		color: '#fff',
		'&:hover': {
			backgroundColor: '#1565c0',
		},
	},
	activityList: {
		padding: theme.spacing(2),
		height: '100%',
		minHeight: "60vh",
		backgroundColor: "#D6DAE7",
		borderRadius: "20px",
		display: 'flex',
    flexDirection: 'column',
    height: '100%',
	},
	inlineText: {
		display: 'flex',
		alignItems: 'center',
		fontSize:"20px",
	},
	spanInlineText: {
		[theme.breakpoints.down('lg')]: { // < 1200px
      fontSize: '16px',
    },
    [theme.breakpoints.down('md')]: { // < 900px
      fontSize: '12px',
    },
    [theme.breakpoints.down('sm')]: { // < 800px
      fontSize: '0px',
      '& > *:not([type="checkbox"])': {
        display: 'none', // Hides all children except checkbox
      },
    },
	},
	activityTitle: {
		fontSize: '2.125rem', // Default h4 size
		fontFamily:"GibsonSemiBd",
		marginLeft:"1vw",
		marginTop:".5vh",
		[theme.breakpoints.down('lg')]: { // < 1200px
			fontSize: '1.75rem',
		},
		[theme.breakpoints.down('md')]: { // < 900px
			fontSize: '1.25rem',
		},
		[theme.breakpoints.down('sm')]: { // < 800px
			fontSize: '1rem',
		},
  },
	number: {
		marginRight: theme.spacing(3),
		fontWeight: 'bold',
		fontSize: "40px",
	},
	autocompleteButton: {
		borderRadius: '20px',
		padding: '4px 16px',
		float: 'right',
	},
	rootForMultiSelect: {
		width: '500px', // Adjust Autocomplete width to make it longer
	},
	textFieldRootForMultiSelect: {
		'& .MuiInputBase-root': {
			minWidth: '500px', // Ensures the TextField itself is longer
			padding: '8px',
		},
	},
	tag: {
		fontSize: '1.4rem', // Increase font size of the pill text
		padding: theme.spacing(0.5, 1.5), // Increase padding for larger pills
		height: 'auto', // Allow height to adjust with content
		minHeight: '40px', // Set a minimum height for larger pills
		// backgroundColor: '#e0f7fa', // Optional: Customize background color
		borderRadius: '16px', // Slightly larger border radius for a softer look
		margin: theme.spacing(0.5), // Adjust spacing between pills
		'& .MuiChip-label': {
			padding: theme.spacing(0, 0.5), // Adjust internal padding of the label
		},
	},
	listItemText: {
    '& .MuiListItemText-primary': {
      fontSize: '1.1rem', // Adjust primary text font size
    },
    '& .MuiListItemText-secondary': {
      fontSize: '1rem', // Adjust secondary text font size
    },
  },
	WbContainer: {
		padding: theme.spacing(1),
		marginLeft:"2vw",
	},
	quoteyBot: {
    height: '12vh', // Adjusted for better responsiveness
    width: 'auto', // Maintain aspect ratio
    maxWidth: '100%', // Prevent overflow
  },
  WBtitle: {
    fontSize: '2.5rem',
		marginLeft:'1vw',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8rem', // Responsive font size for smaller screens
    },
  },
	addProspectButton: {
    borderRadius: 40,
    backgroundColor: '#1976d2',
    color: '#fff',
    width: "100%", 
		height: "6.5vh",
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
    '& .MuiButton-startIcon': {
      marginRight: '8px',
    },
		'& .MuiButton-label': {
			marginLeft: "1rem"
		},
		fontSize:"1.55rem",
		textAlign: 'left',
		display: 'flex', // Ensures button content is flex-aligned
		alignItems: 'center', // Vertically aligns icon and text
		justifyContent: 'flex-start', // Left-aligns the entire content,
		[theme.breakpoints.down('md')]: { // < 900px
			fontSize: '1.125rem',
		},
		[theme.breakpoints.down('sm')]: { // < 800px
			fontSize: '1.7vw',
		},
  },
	circleaddIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '2px solid #fff',
    backgroundColor: 'transparent',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 'bold',
  },
	customAutocomplete: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 40,
			maxWidth:"600px",
      backgroundColor: 'transparent',
      '& fieldset': {
        borderColor: '#1976d2',
				borderWidth: "thick",
      },
      '&:hover fieldset': {
        borderColor: '#1565c0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1565c0',
				borderWidth: "thick"
      },
    },
    '& .MuiInputBase-input': {
      color: '#000',
      padding: '8px 16px',
			fontSize:"1.25rem",
    },
    '& .MuiInputLabel-outlined': {
      color: '#1976d2',
    },
  },
	gridbutton: {
		display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '8px',
    textTransform: 'none',
    textAlign: 'left',
    minHeight: '80px',
    color: (props) => (props.isContained ? '#fff' : '#1976d2'),
    backgroundColor: (props) => (props.isContained ? '#1976d2' : 'transparent'),
    '&:hover': {
      backgroundColor: (props) => (props.isContained ? '#1565c0' : 'rgba(0, 0, 0, 0.04)'),
    },
	}
}));

const HomePage = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const broker = useSelector(getBrokerInformation);
	const isFirstPage = useSelector(getisFirstPage);
	const languagecode = broker?.information?.languagepreference || "en";
	//let languagecode = "fr";
	let fontStyle = { fontFamily: "GibsonSemiBd", fontSize: "1.3vw", color: customTheme.COLORS.primary_navyblue, display: "flex" };

	const [step, setStep] = useState(1);
	const [appDetails, setAppDetails] = useState({});
	const [payload, setPayload] = useState({});
	const [showSpinner, setShowSpinner] = useState(false);
	useEffect(() => {
		dispatch(getMyCustomers());
		dispatch(loadverticals());
		dispatch(loadProducts());
		dispatch(getBrokerStats())
	}, []);
	useEffect(() => {
		  if(broker?.information?.brokeragecode)
				dispatch(loadBrokerageInsurers(broker?.information?.brokeragecode));
		}, [broker?.information?.brokeragecode]);

	useEffect(() => {
		if(step > 1 && isFirstPage){
			dispatch(setFirstPage(false))
		}
		else if(step == 1 && !isFirstPage){
			dispatch(setFirstPage(true))
		}
	}, [step])
	const renderContent = () => {
		switch (step) {
			case 1:
				return <WelcomeBack fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} setAppDetails={setAppDetails} />;
			case 2:
				return <TypeofPolicy fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} setAppDetails={setAppDetails} appDetails={appDetails} type='policy' />;
			case 3:
				return <MultiSelectPage fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} step={step} type="industry" setAppDetails={setAppDetails} appDetails={appDetails}  setPayload={setPayload} />;
			case 4:
				return <MultiSelectPage fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} step={step} type="coverage" setAppDetails={setAppDetails} appDetails={appDetails}  setPayload={setPayload} setShowSpinner={setShowSpinner} showSpinner={showSpinner}/>;
			case 5:
				return <FinalStepsPage fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} step={step} type="fs" setAppDetails={setAppDetails} appDetails={appDetails} setPayload={setPayload} setShowSpinner={setShowSpinner} showSpinner={showSpinner}/>;
			case 6:
				return <InsurerSelection fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} step={step} type="fs" setAppDetails={setAppDetails} appDetails={appDetails} payload={payload} setShowSpinner={setShowSpinner} showSpinner={showSpinner} />;
			default:
				return <WelcomeBack fontStyle={fontStyle} languagecode={languagecode} setStep={setStep} />;
		}
	};
	const prospectidJustCreated = useSelector(getProspectIdJustCreated);
	useEffect(() => {
			if (prospectidJustCreated) {
				document.location.href = `/questions?id=${prospectidJustCreated}`;
			}
		}, [prospectidJustCreated]);

	return (
		<GeneralAuthentication>
			<Container maxWidth={false} className={ step == 1 ? classes.container : null}>
				{/* <HeaderNav /> */}
				{renderContent()}
			</Container>
		</GeneralAuthentication>
	);
};

const WelcomeBack = ({ fontStyle, languagecode, setStep, setAppDetails }) => {
	const classes = useStyles();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const clientList = useSelector(getCustomersTable);
	const broker = useSelector(getBrokerInformation);
	console.log("broker: ", broker)
	let clientListO = [
		{ firstname: 'Sam', lastname: 'Drywall', id: '684328be7580cc23aa3dac10' }
	];
	const [customer, setCustomer] = useState(null);
	const [editActivity, seteditActivity] = useState(false);
	const [activities, setActivities] = useState([
    { code: 'dueReminders', text: { en: 'Reminders due today', "fr": "Rappels dus aujourd'hui" }, description: { en: 'Brokers find this useful', "fr": "Les courtiers trouvent cela utile" }, checked: true, value: broker?.activities?.dueReminders, link:'/reminders?query=overdue' },
    { code: 'mktProspects', text: { en: 'Prospects in market', "fr": "Clients potentiels sur le marché" }, description: { en: 'Brokers find this useful', "fr": "Les courtiers trouvent cela utile" }, checked: true, value: broker?.activities?.mktProspects, link: '/myquotes?status=market' },
    { code: 'clientadjProspects', text: { en: 'Applications with clients', "fr": "Renouvellements en cours" }, description: { en: 'App with Client or finished answering', "fr": "Les courtiers trouvent cela utile" }, checked: true, value: broker?.activities?.clientadjProspects, link:'/myquotes?status=clientadj' },
    { code: 'inprogressProspects', text: { en: 'Prospects In Progress', "fr": "Total des clients potentiels" }, description: { en: 'Admins find this useful',  "fr": "Les administrateurs trouvent cela utile" }, checked: false, value: broker?.activities?.inprogressProspects, link:'/myquotes?status=inprogress' },
    { code: 'quotedProspects', text: { en: 'Quoted Prospects',  "fr": "Clients potentiels avec soumission" }, description: { en: 'Admins find this useful',  "fr": "Les administrateurs trouvent cela utile" }, checked: false, value: broker?.activities?.quotedProspects, link:'/myquotes?status=quoted' },
  ]);

	useEffect(() => {
		console.log("activities: ", broker?.activities);
		if (broker?.activities) {
			setActivities((prevActivities) =>
				prevActivities.map((activity) => ({
					...activity,
					value: broker.activities[activity.code],
				}))
			);
		}
	}, [broker?.activities])


	useEffect(() => {
		let visibleActivityList = broker?.information?.otherinfo?.activitylist;
		if(visibleActivityList){
			setActivities((prevActivities) =>
				prevActivities.map((activity) => ({
					...activity,
					checked: visibleActivityList.includes(activity.code),
				}))
			);
		}
	}, [broker?.information?.otherinfo?.activitylist])

	const updateView = ({code, checked}) => {
		console.log(code, " ", checked);
		setActivities((prevActivities) =>
      prevActivities.map((activity) =>
        activity.code === code ? { ...activity, checked } : activity
      )
    );
	}

	const handleSave = () => {
		seteditActivity(false);
		let viewableActivites = activities.filter(x => x.checked).map(x => x.code);
		console.log(viewableActivites);
		dispatch(
			updateBrokerProfile({
				type: "activitylist",
				data: viewableActivites,
				broker: broker.information,
			})
		);
	}
	const theme = createTheme({
		palette: {
			primary: {
				main: '#739BD0', // Lighter blue (customize as needed)
			},
		},
	});
	const displayOnEdit = editActivity ? undefined: 'none';
	const hideOnEdit = editActivity ? 'none': undefined;
	return (
		<Container maxWidth={false} className={classes.contentGrid}>
			<Grid container spacing={4}> {/* Increased spacing for better layout */}
				<Grid item xs={3}>
					<Paper className={classes.activityList}>
						<div>
							<SaveIcon style={{ float: 'right', display: displayOnEdit, fontSize: '44px'  }} onClick={handleSave}/>
							<SettingsIcon style={{ float: 'right', display: hideOnEdit, fontSize: '44px' }} onClick={() =>  seteditActivity(true)}/>
							<Typography className={classes.activityTitle}>{ language[languagecode].activity_snapshot }</Typography> {/* Larger variant */}
						</div>
						<ThemeProvider theme={theme}>
							<List  style={{ flexGrow:1 }}>
							{
							activities.map(activity => (
								<ListItem key={activity.code} style={{ 'display': editActivity ? null : activity.checked ? null : 'none' }} >
									<ListItemText
										disableTypography
										primary={
											<Grid container alignItems="center" spacing={1} style={{'display':'flex', 'flexFlow':'row'}}>
												<Grid item style={{ display: displayOnEdit  }}>
													<Checkbox 
														color="primary" 
														checked={activity.checked} 
														size='medium' 
														onChange={(event) => { updateView({ code: activity.code, checked: event.target.checked }) }} 
													/>
												</Grid>
												<Grid container alignItems="center">
													<Grid item style={{ display: hideOnEdit, textAlign:'right', minWidth:"3.2vw" }} className={classes.number}>
															{activity.value}
													</Grid>
													<Grid item xs className={classes.spanInlineText} style={{ display: 'inline-block', marginLeft:'1vw', verticalAlign: 'top' }}>
															{activity.text[languagecode]}
													</Grid>
												</Grid>
											</Grid>
										}
										secondary={
											<div style={{display: displayOnEdit, marginLeft: 'calc(40px + 2vw)', 'fontSize':'12px' }}>
													{activity.description?.[languagecode]}
											</div>
										}
									/>
									<IconButton size="medium" style={{'display': hideOnEdit }} onClick={() => {
										if(activity.link){
											navigate(activity.link)
										}
									}}>
										<svg width="24" height="24" viewBox="0 0 24 24">
											<path d="M8 6L14 12L8 18H10L15 12L10 6H8Z" fill="currentColor" />
										</svg>
									</IconButton>
								</ListItem>
							))
						}
						</List>
						<div style={{display: 'flex', justifyContent: 'center' , alignItems: 'center'}}>
								<OrangeButton
									text={language[languagecode].view_sales_pipeline}
									color={customTheme.COLORS.primary_navyblue}
									width="10vmin"
									onClick={() => {
										//dispatch(storeProspectid(prospectid));
										navigate(`/myquotes`);
										//document.location.href = `/prospect?id=${prospectid}`;
									}}
								></OrangeButton>
						</div>
						</ThemeProvider>
					</Paper>
				</Grid>
				<Grid item xs={8}>
					<Grid container spacing={4}>
						<Grid container alignItems="center" spacing={0} className={classes.WbContainer}>
							<Grid item xs={3} sm={1}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									{quoteyBot ? (
										<img src={quoteyBot} className={classes.quoteyBot} alt="quoteyrobo" style={{ height: '20vh', width:"auto", marginRight:'1.5rem', scale:'1.8' }} />
									) : (
										<div>Image not found</div>
									)}
								</div>
							</Grid>
							<Grid item xs={9} sm={10}>
								<Typography variant="h3" style={{ ...fontStyle, fontSize: '3.5rem' }} className={classes.WBtitle} >
									{translations[languagecode].welcomeBack} {" " + broker?.information?.firstname + "!"}
								</Typography>
							</Grid>
						</Grid>
						<Grid container spacing={4} style={{ marginLeft: '3vw' }}>
						  <Grid item xs={6}>
							<Typography variant="h6" className={classes.subtitle}> {language[languagecode].create_new_client} </Typography>
							<Typography variant="body1" className={classes.description}> {language[languagecode].create_new_client_description} </Typography>
							<div style={{ width: "80%" }}>
								<Button
									className={classes.addProspectButton}
									startIcon={<span className={classes.circleaddIcon}>+</span>}
									onClick={() => setStep(2)}
									>
									{language[languagecode].create_new_client_btn}
								</Button>
							</div>
							</Grid>
							<Grid item xs={6}>
								<Typography variant="h6" className={classes.subtitle}> {language[languagecode].find_existing_client}</Typography>
								<Typography variant="body1" className={classes.description}>{language[languagecode].find_existing_client_desc}</Typography>
								<div style={{ width: "80%" }}>
									<Autocomplete
										className={classes.customAutocomplete}
										disabled={clientList == null} 
										options={clientList}
										getOptionLabel={(broker) => broker.company || broker.name || broker.contacts?.[0]?.name }
										onChange={(e, client) => setCustomer(client)}
										renderInput={(params) => (
											<TextField
											{...params}
											
											variant="outlined"
											placeholder={`${translations[languagecode].search}...`}
											InputProps={{
												...params.InputProps,
												style: { height: '6.5vh' },
												startAdornment: (
													<InputAdornment position="start">
															<SearchIcon style={{ color: '#1976d2' }} />
														</InputAdornment>
													),
													endAdornment: (
														<InputAdornment position="end">
															<Button
																variant="contained"
																color="primary"
																size="medium"
																style={{ borderRadius: '20px', 'display': customer ? null : 'none', marginBottom: "0.85vh" }} // Rounder button
																onClick={() => {
																	console.log("GO CLICKED");
																	console.log(customer);
																	navigate(`/customer?id=${customer._id}`)
																	// setAppDetails((obj) => ({
																		// 	...obj,
																		// 	customer,
																		// }));
																		// setStep(2);
																	}}
																	>
																{language[languagecode].find_existing_btn_text}
															</Button>
														</InputAdornment>
													),
												}}
											/>
										)}
										renderOption={(option) => (
											<li style={{ padding: '8px 16px', color: '#333' }}>{option.company || option.name}</li>
										)}
										PaperComponent={({ children }) => (
											<Paper style={{ backgroundColor: '#f5f5f5', borderRadius: '8px', marginTop: '4px' }}>
												{children}
											</Paper>
										)}
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
};

const TypeofPolicy = ({ fontStyle, languagecode, setStep, type, setAppDetails, appDetails }) => {
	const classes = useStyles();
	const [selected, setSelected] = useState(appDetails?.[type]);

	//const options = ['Business', 'Individual', 'Farm'];
	const options = [{code:'Business', en:'Business / Commerical', fr:'Entreprise'}, {code:'Individual', en:'Individual / Personal', fr:'Particulier'}, {code:'Farm', en:'Farm', fr:'Ferme'}];
	const policyHelpSideBar = {
		'title': {'en': "How to choose the right policy type", 'fr':'Comment choisir le bon type de police'},
		'helptext': {
			'en': [ {primary: "Business",secondary: "Select Business for any activity that earns revenue or provides services to others—even if the owner is a sole proprietor, freelancer, independent contractor, or side-gig operator who has not incorporated. Classifying these clients as “Business” unlocks the commercial wordings, limits, and extensions they will need (e.g., commercial general liability, cyber, or professional liability)."}, {primary: "Individual",secondary: "Choose Individual only when the coverage is purely personal and not connected to a trade, profession, or income-producing activity. Think of situations such as personal umbrella liability, watercraft, or a homeowner looking to insure collectibles. If any part of the exposure is commercial, move up to Business."}, {primary: "Farm",secondary: "Select Farm when the principal exposure involves agricultural operations—crops, livestock, or hobby farms—even if the insured lives on the property. Farm packages blend personal-dwelling and commercial-agri-coverages, so choosing this path ensures the application captures both sets of risks."}],
			'fr': [ {primary: "Entreprise", secondary: "Sélectionnez Entreprise pour toute activité qui génère des revenus ou fournit des services à autrui — même si le propriétaire est un travailleur autonome, un pigiste, un entrepreneur indépendant ou un opérateur d'activité secondaire non incorporé. Classifier ces clients comme « Entreprise » débloque les formulations commerciales, les limites et les extensions dont ils auront besoin (par exemple, responsabilité civile générale commerciale, cyberassurance ou responsabilité professionnelle)."}, {primary: "Particulier" ,secondary: "Choisissez Particulier uniquement lorsque la couverture est strictement personnelle et non liée à un commerce, une profession ou une activité génératrice de revenus. Pensez à des situations comme la responsabilité civile personnelle, les embarcations ou un propriétaire cherchant à assurer des objets de collection. Si une partie de l'exposition est commerciale, optez pour Entreprise."}, {primary: "Ferme",secondary: "Sélectionnez Ferme lorsque l'exposition principale concerne des opérations agricoles — cultures, bétail ou fermes de loisir — même si l'assuré vit sur la propriété. Les forfaits pour fermes combinent les couvertures pour habitation personnelle et les couvertures agricoles commerciales, donc choisir ce chemin garantit que la demande capture les deux ensembles de risques."}]
		}
	}
	return (
		<Container  maxWidth={false} className={classes.contentGrid}>
			<Grid container spacing={3}>
				<Grid item xs={8}>
					<Grid container spacing={4}>
						<ApplicationHeader fontStyle={fontStyle} title={language[languagecode].new_app_bld} classes={classes} />
						<Grid item xs={10} className={classes.questionArea}>
							<span className={classes.subtitle}>{language[languagecode].policy_q}</span>
							<p className={classes.description}>{language[languagecode].policy_q_description}</p>
							<div style={{ width: "100%" }}>
								<Box className={classes.toggleContiner}>
									{options.map((option) => (
										<Button
											key={option.code}
											variant="contained"
											className={`${classes.toggleButton} ${classes.largeToggleButton} ${selected === option.code ? classes.selected : ''}`}
											onClick={() => {
												setSelected(option.code);
												setAppDetails((obj) => ({
													//...obj,
													[type]: option.code,
												}));
											}}
										>
											{option[languagecode]}
										</Button>
									))}
								</Box>
							</div>
						</Grid>
						<Grid item xs={8}>
							<NavigationButtons
								onPrev={() => setStep((prevCount) => prevCount - 1)}
								onNext={() => {
									if(selected == 'Business') //show which industry page
										setStep((prevCount) => prevCount + 1)
									else
										setStep((prevCount) => prevCount + 2)
								}}
								disabledNext={ selected == undefined }
								classes={classes}
								languagecode={languagecode}
							/>
						</Grid>
					</Grid>
				</Grid>
				<HelpSidebar
					title={policyHelpSideBar.title[languagecode]}
					helpItems={policyHelpSideBar.helptext[languagecode]}
					classes={classes}
				/>
			</Grid>
		</Container>
	);
};

const MultiSelectPage = ({ fontStyle, languagecode, setStep, step, type, setAppDetails, appDetails, setPayload, setShowSpinner, showSpinner  }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const isMultiple = type === 'coverage';
	const [product, setProduct] = useState(null);
	const [packageDetails, setPackageDetails] = useState({});
	const [finalStep, setfinalStep] = useState(false);
	const [coverageQuestions, setCoverageQuestions] = useState([]);
	const [coverageQuestionsStandAlone, setCoverageQuestionsStandAlone] = useState([]);
	const [coverageQuestionsPackage, setCoverageQuestionsPackage] = useState([]);
	const [showGrid, setShowGrid] = useState(false);
 	const productList = useSelector(getProductList);
	const insurerList = useSelector(getInsurersList);
  const handleToggleView = () => {
    setShowGrid((prev) => !prev);
  };

	const handleGridButtonClick = (option) => {
    if (type === 'coverage') {
      // Handle multiple selections
      const isSelected = Array.isArray(selected) && selected.some((item) => item.code === option.code);
      let newValue;
      if (isSelected) {
        // Remove option if already selected
        newValue = selected.filter((item) => item.code !== option.code);
      } else {
        // Add option, ensuring uniqueness by code
        newValue = [...(Array.isArray(selected) ? selected : []), option];
        newValue = [...new Map(newValue.map((item) => [item.code, item])).values()];
      }
      setSelected(newValue);
      setAppDetails((obj) => ({
        ...obj,
        [type]: newValue,
      }));
    } else {
      // Handle single selection
			console.log("Handle single select")
			console.log(option)
      const newValue = selected?.id === option.id ? null : option;
      setSelected(newValue);
      setAppDetails((obj) => ({
        ...obj,
        [type]: newValue,
      }));
    }
  };

	const [selected, setSelected] = useState(() => {
		const val = appDetails?.[type];
		if (isMultiple) return Array.isArray(val) ? val : [];
		return typeof val === 'object' && val !== null ? val : null;
	});
	let verticals = useSelector(getVerticalList);
	useEffect(() => {
		const val = appDetails?.[type];
		if (type === 'coverage') {
			setSelected(Array.isArray(val) ? val : []);
		} else {
			setSelected(typeof val === 'object' && val !== null ? val : null);
		}
	}, [step, appDetails, type]);
	// console.log("type: ", type);
	// console.log("Selected: ", selected);
	useEffect(() => {
		if(isMultiple && Array.isArray(selected)){
			// console.log("inside use Effect");
			// console.log("selected: ", selected);
			// let coverageCodes = selected?.map(x => x.code);
			// if(selected.length == 1){
			// 	setfinalStep(true)
			// }
			// else if ( selected.length == 0) {
			// 	setfinalStep(false)
			// }
			// else{
			// 	const possibleTriageQuestionCodes = [
			// 		"CYBER",
			// 		"ManagementLiability",
			// 		"LEGAL EXPENSE",
			// 	];
				
			// 	if(coverageCodes.some(item => possibleTriageQuestionCodes.includes(item))  ){
			// 		setfinalStep(false)
			// 	} else {
			// 		// check if its general liability or comercial package and CARGO or comml construction and set final step to false
			// 		if( ( coverageCodes.includes("CARGO") || coverageCodes.includes("CONSTRUCTION") ) && ( coverageCodes.includes('') ) )
			// 		console.log(selected);
			// 		setfinalStep(true)
			// 	}

			// }
			calculatePackageDetails({coverageToggles:appDetails.coverage, setProduct, setSelected:setPackageDetails, setCoverageQuestions, setCoverageQuestionsStandAlone, setCoverageQuestionsPackage, type, productList, industryId: appDetails.industry?.id }  )
		}else {
			setfinalStep(false);
		}
		
	},[type, selected])

	useEffect(()=> {
		// this is the handler to determine if final page needs to be rendered.
		// console.log("INSIDE USE EFFECT");
		// console.log("insurerList: ", insurerList);
		// console.log("coverageQuestionsPackage ", coverageQuestionsPackage);
		// console.log("appDetails ", appDetails);
		let potentialSelectedVerticalid = null; 
		if(isMultiple && coverageQuestionsPackage.length > 0){
			potentialSelectedVerticalid = coverageQuestionsPackage[0].verticalid;
			if(potentialSelectedVerticalid == 0){
				potentialSelectedVerticalid = appDetails.industry.id;
			}
		} else if(isMultiple && coverageQuestionsStandAlone.length > 0){
			// this block fires if coverageQuestionsPackage length is 0 but we have 1+ standalones
			potentialSelectedVerticalid = coverageQuestionsStandAlone[0].verticalid;
		}
		const insurers = potentialSelectedVerticalid ? insurerList.filter((x) => x.verticalids.includes(potentialSelectedVerticalid)) : [];
	  if( isMultiple &&  Array.isArray(selected) && insurers.length == 0 && coverageQuestions.length == 0 ) { // 
			setfinalStep(true);
		}
		else 
			setfinalStep(false);
	}, [coverageQuestions])

	let valueDict = {
		'industry': {
			'title': {
				'en': 'What is the primary industry sector?',
				'fr': 'Quel est le secteur industriel principal?'
			},
			'subtitle': {
				'en': 'Select the main industry sector that this business belongs to. You can select specific operations later in the application.',
				'fr': 'Sélectionnez le secteur d\'activité principal auquel appartient cette entreprise. Vous pourrez sélectionner des activités spécifiques ultérieurement dans l\'application.',
			},
			'options': [
				{ 'code': 'contractor', 'text': { 'en': 'Contractor', 'fr': 'Contra' }, 'description': { 'en': 'fixing house', 'fr': 'some french fries' } },
				{ 'code': 'pservices', 'text': { 'en': 'Professional Services', 'fr': 'Contra' }, 'description': { 'en': 'HairCut anyone?', 'fr': 'some french fries' } },
				{ 'code': 'og', 'text': { 'en': 'Oil & Gas', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } }
			],
			'helptextTitle': {'en':'Choosing the Main Industry Vertical', 'fr':'Choisir le secteur d\'activité principal'},
			'helptext': {
				"en": [
					{ 'primary': '', 'secondary': 'Pick the single category that best reflects where the client earns most of its revenue today. Accurate classification unlocks the right underwriting questions, coverage extensions, and pricing models later in the application, so time spent here prevents re-work downstream.' },
					{ 'primary': 'Focus on the core business activity', 'secondary': 'The vertical should match the primary product or service that drives revenue, not occasional or incidental side lines. Example: A café that sells branded mugs should be “Hospitality / Food Service,” not “Retailer,” because food service is its core trade' },
					{ 'primary': 'Ignore legal structure', 'secondary': 'Whether the firm is incorporated, a partnership, or a sole proprietorship doesn’t affect the vertical choice. A one-person consulting practice is still “Professional Services,” not “Individual.”' },
					{ 'primary': 'When operations span multiple areas, choose the dominant one', 'secondary': 'If revenue is split 70 % manufacturing and 30 % retail storefront, select “Manufacturing.” You’ll be able to describe the secondary exposure in the follow-up operations section.' },
					{ 'primary': '', 'secondary': 'If you’re unsure, ask the client, “What do you get paid for most often?” and choose the vertical that best matches that answer. You’ll refine the exact operations in the next step, so precision on the headline category is what matters here.' },
				],
				"fr": [
					{ "primary": "", "secondary": "Choisissez la catégorie unique qui reflète le mieux la source principale de revenus du client aujourd'hui. Une classification précise permet de débloquer les bonnes questions de souscription, les extensions de couverture et les modèles de tarification plus tard dans la demande, ce qui évite des retouches ultérieures."},
					{ "primary": "Concentrez-vous sur l'activité principale","secondary": "Le secteur doit correspondre au produit ou service principal qui génère les revenus, et non aux activités secondaires ou occasionnelles. Exemple : un café qui vend des tasses de marque doit être classé dans « Hôtellerie / Restauration », et non dans « Commerce de détail », car la restauration est son activité principale."},
					{ "primary": "Ignorez la structure juridique","secondary": "Que l'entreprise soit une société, un partenariat ou une entreprise individuelle n'affecte pas le choix du secteur. Une pratique de conseil à une seule personne reste dans « Services professionnels », et non dans « Particulier »."},
					{ "primary": "Lorsque les opérations couvrent plusieurs domaines, choisissez le dominant", "secondary": "Si les revenus sont répartis à 70 % dans la fabrication et à 30 % dans un magasin de détail, sélectionnez « Fabrication ». Vous pourrez décrire l'exposition secondaire dans la section des opérations suivantes."},
					{ "primary": "","secondary": "Si vous n'êtes pas sûr, demandez au client : « Pour quoi êtes-vous payé le plus souvent ? » et choisissez le secteur qui correspond le mieux à cette réponse. Vous affinerez les opérations exactes à l'étape suivante, donc la précision sur la catégorie principale est ce qui compte ici."}
				]
			}
		},
		'coverage': {
			'title': {
				'en': 'What coverages would you like included?',
				'fr': 'Quelles couvertures souhaitez-vous inclure ?'
			},
			'subtitle': {
				'en': 'Select one or more that should be included in the application. Make sure you select Property if there is any element of property coverage required including buildings, contents, equipment, or stock.',
				'fr': 'Sélectionnez une ou plusieurs couvertures à inclure dans la demande. Assurez-vous de sélectionner la couverture des biens si un élément de couverture des biens est requis, y compris les bâtiments, le contenu, l’équipement ou le stock.',
			},
			'options': {
				'Individual':[
					{ 'code': 'Residential', 'name': { 'en': 'Residential', 'fr': 'Résidentiel' }, 'description': { 'en': '', 'fr': '' }, 'industry' : { id: 6 } },
					{ 'code': 'StudentHousing', 'name': { 'en': 'Student Housing', 'fr': 'Logement étudiant' }, 'description': { 'en': '', 'fr': '' },'industry' : { id: 6 } },
					{ 'code': 'RentedDwelling', 'name': { 'en': 'Rented dwelling', 'fr': 'Logement loué' }, 'description': { 'en': '', 'fr': '' }, 'industry' : { id: 6 } },
					{ 'code': 'CONSTRUCTION', 'name': { 'en': 'Course of Construction', 'fr': 'Cours de construction' }, 'description': { 'en': '', 'fr': '' },'industry' : { id: 6 } },
					{ 'code': 'VacantProperty', 'name': { 'en': 'Vacant Property', 'fr': 'Propriété vacante' }, 'description': { 'en': '', 'fr': '' },'industry' : { id: 6 } },
					{ 'code': 'VacantLand', 'name': { 'en': 'Vacant Land', 'fr': 'Terrain vacant' }, 'description': { 'en': '', 'fr': '' }, 'industry' : { id: 6 } },
				],
				'Farm':[
					{ 'code': 'HobbyFarm', 'name': { 'en': 'Hobby Farm', 'fr': 'Ferme d\'agrément' }, 'description': { 'en': '', 'fr': '' }, 'industry' : { id: 63 } },
					{ 'code': 'CommercialFarm', 'name': { 'en': 'Commercial Farm', 'fr': 'Ferme commerciale' }, 'description': { 'en': '', 'fr': '' }, 'industry' : { id: 9 } },
					{ 'code': 'Hail', 'name': { 'en': 'Hail', 'fr': 'Grêle' }, 'description': { 'en': '', 'fr': '' }, 'industry' : { id: 74 } },
				],
				'Business':[
					{ 'code': 'GeneralLiability', 'name': { 'en': 'General Liability', 'fr': 'Contra' }, 'description': { 'en': 'fixing house', 'fr': 'some french fries' } },
					{ 'code': 'Property', 'name': { 'en': 'Property (of every description)', 'fr': 'Contra' }, 'description': { 'en': 'fixing house', 'fr': 'some french fries' } },
					{ 'code': 'ProfessionalLiability', 'name': { 'en': 'Professional Liability', 'fr': 'Contra' }, 'description': { 'en': 'HairCut anyone?', 'fr': 'some french fries' } },
					{ 'code': 'CYBER', 'name': { 'en': 'CYBER', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'ManagementLiability', 'name': { 'en': 'Management Liability', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'FLEET', 'name': { 'en': 'Auto Fleet', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'CARGO', 'name': { 'en': 'CARGO', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'CONSTRUCTION', 'name': { 'en': 'Course of Construction', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'LEGAL EXPENSE', 'name': { 'en': 'Legal Expenses', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'Surety', 'name': { 'en': 'Surety', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'DisabilityPA', 'name': { 'en': 'Disability & PA', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'Environmental', 'name': { 'en': 'Environmental', 'fr': '' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'Crime', 'name': { 'en': 'Crime', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'TerrorismPoliticalRisk', 'name': { 'en': 'Terrorism & Political Risk', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' }, 'hideOnOperations': [1]  },
					{ 'code': 'Excess', 'name': { 'en': 'Excess', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'ProductRecall', 'name': { 'en': 'Product Recall', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'EquipmentBreakdown', 'name': { 'en': 'Equipment Breakdown', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } , },
					{ 'code': 'Events', 'name': { 'en': 'Events', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'Benefits', 'name': { 'en': 'Benefits', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					{ 'code': 'Hail', 'name': { 'en': 'Hail', 'fr': 'Contra' }, 'description': { 'en': 'Diging pipeLine', 'fr': 'some french fries' } },
					
				]
			},
			'helptextTitle': {'en': 'How to Choose the Primary Coverages', 'fr': 'Comment choisir les couvertures principales' },
			'helptext': {
				'en': [	
					{ 'primary': '', 'secondary': 'Select every coverage the client needs—the system opens follow-up questions only for the options you choose, so accuracy here saves time later' },
					{ 'primary': 'Select multiple, not just one', 'secondary': 'The combination you pick determines how we bundle limits (e.g., whether cyber should ride on a package or stand alone). If you miss something now, you’ll have to restart to add it.' },
					{ 'primary': 'Always include “Property” for any physical assets.', 'secondary': 'That covers owned buildings, tenant improvements, gear, or stock—even if they’re kept in a rented unit or the owner’s home office.' },
					{ 'primary': 'Think exposures, not line items', 'secondary': 'Ask yourself: What could cost this client money if it’s damaged or they’re sued? Choose every coverage that answers that question.' },
					{ 'primary': 'When unsure, be inclusive.', 'secondary': 'It’s easier to slim down later than to rebuild an application.\nGetting the foundation right here ensures the application surfaces the correct underwriting paths, limits, and package options without back-tracking.' },
					{ 'primary': '', 'secondary': 'In some cases, Quotey will automatically create a separate line of business opportunity for this client, i.e. if you want standalone cyber insurance to sit alongside a traditional commercial package.' },
					{ 'primary': '', 'secondary': 'You can also now cross sell faster than ever by creating new opportunities in our client manager.' },
				],
				'fr': [	
					{ 'primary': '', 'secondary': 'Sélectionnez toutes les couvertures dont le client a besoin — le système ouvre des questions complémentaires uniquement pour les options choisies, donc une précision ici permet de gagner du temps plus tard.' },
					{ "primary": "Sélectionnez plusieurs options, pas seulement une", "secondary": "La combinaison que vous choisissez détermine comment nous regroupons les limites (par exemple, si la cyberassurance doit être intégrée à un forfait ou être autonome). Si vous omettez quelque chose maintenant, vous devrez recommencer pour l’ajouter."},
					{ "primary": "Incluez toujours « Biens » pour tout actif physique.", "secondary": "Cela couvre les bâtiments possédés, les améliorations locatives, l’équipement ou le stock — même s’ils sont conservés dans une unité louée ou au bureau à domicile du propriétaire."},
					{ "primary": "Pensez en termes d’expositions, pas de postes individuels", "secondary": "Demandez-vous : qu’est-ce qui pourrait coûter de l’argent à ce client en cas de dommage ou de poursuite ? Choisissez toutes les couvertures qui répondent à cette question."},
					{ "primary": "En cas de doute, soyez inclusif.", "secondary": "Il est plus facile de réduire plus tard que de reconstruire une demande. Poser les bonnes bases ici garantit que la demande propose les bons chemins de souscription, limites et options de forfait sans avoir à revenir en arrière."},
					{ "primary": "", "secondary": "Dans certains cas, Quotey créera automatiquement une opportunité distincte pour ce client, par exemple, si vous souhaitez une cyberassurance autonome à côté d’un forfait commercial traditionnel."},
					{ "primary": "", "secondary": "Vous pouvez également maintenant vendre de manière croisée plus rapidement que jamais en créant de nouvelles opportunités dans notre gestionnaire de clients."	}
				]
			}
			
		}
	};
	//console.log("productList: ", productList);
	let policyType = appDetails['policy'];
	// console.log("policyType: ", policyType);
	// console.log("type: ", type)
	let options = valueDict[type].options[policyType];
	if(type == 'industry'){
		let notIndustries = [ 7, 9, 29, 30, 31, 33, 34, 36, 37, 40, 41, 42, 44, 47, 48, 49, 54, 63, 64, 65, 67, 72, 73, 74, 99, 0 ]
		let verticalsM = verticals.map(option => ({ ...option, code:option.id ?? '' })).filter(option => !notIndustries.includes(option.id) );
		options = verticalsM;
	}
	else if( type == 'coverage' && appDetails?.['policy'] == 'Business'){
		//console.log("COVERAGE");
		//console.log(options)
		options = productList.filter(x => x.category == 'Business');
		//console.log("appDetails: ", appDetails);
		let industryId = appDetails?.industry?.id;
		options = options.filter(x => !x.hideOnOperations?.includes(industryId))
	}
	else if (type == 'coverage' ) {
		options = productList.filter(x => x.category == appDetails?.['policy'] );
	}
	// console.log("selected: ", selected)
	// console.log("options: ", options)
	return (
		<Container  maxWidth={false} className={classes.contentGrid}>
			<Grid container spacing={3}>
				<Grid item xs={8}>
					<Grid container spacing={4}>
						<ApplicationHeader fontStyle={fontStyle} title={language[languagecode].new_app_bld} classes={classes} />
						<Grid item xs={9} className={classes.questionArea}>
            		<div style={{ flex: '0 0 100%', paddingRight: '16px' }}> {/* 80% width for Autocomplete, matches xs={10} */}
									<span className={classes.subtitle}>{valueDict[type].title[languagecode]}</span>
									<p className={classes.description}>{valueDict[type].subtitle[languagecode]}</p>
									<div style={{ flex: '0 0 100%', display: 'flex', alignItems: 'center' }}> {/* 20% width for text, matches xs={4} */}
										<button
											onClick={handleToggleView}
											style={{ cursor: 'pointer', color: '#1976d2', marginBottom: '16px', background: 'none', border: 'none', padding: 0 }}
										>
											{showGrid ? translations[languagecode].selectFromDropdown : translations[languagecode].selectFromGrid}
										</button>
									</div>
									<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
									{showGrid ? (
										<div style={{ width: '100%' }}>
											<Box
												className={classes.root}
												style={{
													display: 'grid',
													gridTemplateColumns: 'repeat(4, 1fr)',
													gridAutoRows: 'min-content', // Adjust row height based on content
													gap: '8px',
													maxHeight: '32vh', // Optional: limit height with scroll
													overflowY: 'auto', // Enable scrolling if many options
												}}
											>
												{options.map((option) => (
													<GridButton 
														option={option} 
														selected={selected}
														type={type} 
														languagecode={languagecode}
														handleGridButtonClick={handleGridButtonClick}
													/>
												))}
											</Box>
										</div>
										) : (
										<div style={{ width: '80%' }}>
											<Box className={classes.root}>
												<Autocomplete
													id={`MulitiSelect_${type}`}
													className={classes.autocompleteContainer}
													disableCloseOnSelect
													getOptionLabel={(option) => {
														if (!option || typeof option !== 'object') return '';
														const name = option.name?.[languagecode] || '';
														const description = option.description?.[languagecode] || '';
														return name;
														return `${name} ${description}`.trim();
													}}
													multiple={type === 'coverage'}
													options={options}
													classes={{
														input: classes.input,
														tag: classes.tag,
													}}
													value={
														type === 'coverage'
															? Array.isArray(selected) ? selected : []
															: typeof selected === 'object' && selected !== null ? selected : null
													}
													onChange={(e, newValue) => {
														if (Array.isArray(newValue)) {
															newValue = [...new Map(newValue.map((item) => [item.code, item])).values()];
														}
														setSelected(newValue);
														setAppDetails((obj) => ({
															...obj,
															[type]: newValue,
															'sa_or_pkg':false,
														}));
													}}
													renderOption={(option) => (
														<div style={{ width: '100%' }}>
															<div style={{ fontWeight: 'bold' }}>{option.name[languagecode]}</div>
															<div style={{ color: '#666', fontSize: '0.875rem' }}>{option.description[languagecode]}</div>
														</div>
													)}
													renderInput={(params) => (
														<TextField
															{...params}
															classes={{ root: classes.textFieldRootForMultiSelect }}
															className={classes.largeTextField}
															placeholder={isMultiple ? translations[languagecode].selectMultiple : translations[languagecode].selectOne}
															fullWidth
														/>
													)}
												/>
											</Box>
										</div>
										)}
										
								</div>
							</div>
						</Grid>
						
						<Grid item xs={8}>
							<NavigationButtons
								onPrev={() => {
									if(appDetails?.policy == 'Business') //show which industry page
										setStep((prevCount) => prevCount - 1)
									else
										setStep((prevCount) => prevCount - 2)
								}}
								onNext={() => {
									// console.log("appDetails ",appDetails);
									// console.log("selected ",selected)
									// console.log("packageDetails ",packageDetails)
									// console.log("product ", product)
									//return;
									let verticalid = appDetails.industry?.id || selected[0].industry?.id
									const create_opp_payload = {
										operations: [{ vertical: appDetails.industry, verticalid }],
										productcode: product,
										selectedverticalid: verticalid,
										coverages: selected,
										appdetails: {...appDetails, packageDetails},
										customerid: appDetails?.customer?._id,
										prospectids: appDetails?.customer?.prospectids,
									};
									console.log(create_opp_payload)
									setPayload(create_opp_payload)
									if(finalStep){
										// console.log(appDetails)
										// console.log(selected)
										setShowSpinner(true)
										dispatch(createProspectByCallingAPI(create_opp_payload));
									}
									else{
										// if packageQuestions +1 otherwise no package questions and insurers + 2
										let stepCount = 1
										if(coverageQuestions.length == 0 && isMultiple){
											stepCount = 2
										}
											setStep((prevCount) => prevCount + stepCount)
									}
								}}
								nextLabel= { finalStep ? language[languagecode].start_app : null}
								classes={classes}
								disabledNext={ selected == null || ( Array.isArray(selected) && selected.length == 0 ) }
								languagecode={languagecode}
								showSpinner={showSpinner}
							/>
						</Grid>
					</Grid>
				</Grid>
				<HelpSidebar
					title={valueDict[type].helptextTitle[languagecode]}
					helpItems={valueDict[type].helptext[languagecode]}
					classes={classes}
				/>
			</Grid>
		</Container>
	);
};

const FinalStepsPage = ({ fontStyle, languagecode, setStep, step, type, appDetails, setAppDetails, setPayload, setShowSpinner, showSpinner }) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const [selected, setSelected] = useState({});
	const [coverageQuestions, setCoverageQuestions] = useState([]);
	const [coverageQuestionsStandAlone, setCoverageQuestionsStandAlone] = useState([]);
	const [coverageQuestionsPackage, setCoverageQuestionsPackage] = useState([]);
	const [product, setProduct] = useState(null);
	const coverageToggles = useMemo(() => appDetails?.coverage || [], [appDetails?.coverage]);
	const  productList = useSelector(getProductList);
	const insurerList = useSelector(getInsurersList);
	let potentialSelectedVerticalid = null;
	if( coverageQuestionsPackage.length > 0){
		potentialSelectedVerticalid = coverageQuestionsPackage[0].verticalid;
		let overRideVertical = coverageQuestionsPackage[0].otherinfo?.verticaloverride?.find(override => override.operations.includes(appDetails.industry.id));
		if(overRideVertical){
			potentialSelectedVerticalid = overRideVertical.overrideverticalid;
		}
		if(potentialSelectedVerticalid == 0){
			potentialSelectedVerticalid = appDetails.industry.id;
		}
	}
	const insurers = potentialSelectedVerticalid ? insurerList.filter((x) => x.verticalids.includes(potentialSelectedVerticalid)) : [];
	console.log("insurerList", insurerList)
	console.log("insurers: ", insurers);

	useEffect(() => {		
		setAppDetails((prev) => ({
			...prev,
			packageDetails: selected,
			'sa_or_pkg':true,
		}));
	}, [selected, setAppDetails]);

	useEffect(() => {
		// console.log(coverageToggles)
		// console.log("type: ", type)
		calculatePackageDetails({ coverageToggles, setProduct, setSelected, setCoverageQuestions, setCoverageQuestionsStandAlone, setCoverageQuestionsPackage, type, productList, industryId: appDetails.industry.id  } )
		return 
		
		let newProduct = null;
		const newCoverageQuestions = [];
		const newCoverageQuestionsStandAlone = [];
		const newCoveragePackages = [];

		if (coverageToggles.length === 1) {
			newProduct = coverageToggles[0].code;
			// switch (coverageToggles[0].code) {
			// 	case "GeneralLiability":
			// 		newProduct = "GeneralLiability";
			// 		break;
			// 	case "Property":
			// 		newProduct = "Commercial Property";
			// 		break;
			// 	case "ProfessionalLiability":
			// 		newProduct = "Professional Liability";
			// 		break;
			// 	case "CYBER":
			// 		newProduct = "CYBER";
			// 		break;
			// 	case "ManagementLiability":
			// 		newProduct = "D&O";
			// 		break;
			// 	case "LEGAL EXPENSE":
			// 		newProduct = "LEGAL EXPENSE";
			// 		break;
			// 	case "FLEET":
			// 		newProduct = "Auto Fleet";
			// 		break;
			// 	case "CARGO":
			// 		newProduct = "CARGO";
			// 		break;
			// 	default:
			// 		newProduct = coverageToggles[0].code;
			// 		break;
			// }
		} else {
			const coverageCodes = coverageToggles.map((x) => x.code);
			let foundCoverage = null;
			const possibleTriageQuestionCodes = [
				"CYBER",
				"ManagementLiability",
				"D&O",
				"LEGAL EXPENSE",
				"CARGO",
				"CONSTRUCTION",
			];
			if (coverageCodes.includes("ProfessionalLiability")) {
				newProduct = "ProfessionalLiability";
				foundCoverage = coverageToggles.find(x => x.code == 'ProfessionalLiability');
				newCoveragePackages.push(foundCoverage)
			}
			else if ( ["GeneralLiability", "Property"].every((value) => coverageCodes.includes(value)) ) {
				newProduct = "GeneralLiability";
				foundCoverage = coverageToggles.find(x => x.code == 'GeneralLiability');
				newCoveragePackages.push(foundCoverage)
				foundCoverage = coverageToggles.find(x => x.code == 'Property');
				newCoveragePackages.push(foundCoverage)

			} else if (coverageCodes.includes("GeneralLiability")) {
				newProduct = "GeneralLiability";
				foundCoverage = coverageToggles.find(x => x.code == 'GeneralLiability');
				newCoveragePackages.push(foundCoverage)
			} 

			// coverages that are packages only in multi
			if( coverageCodes.includes("FLEET") ){
				foundCoverage = coverageToggles.find(x => x.code == 'FLEET');
				newCoveragePackages.push(foundCoverage)
			}

			for (const code of possibleTriageQuestionCodes) {
				foundCoverage = coverageToggles.find((x) => x.code === code);
				if (foundCoverage) {
					if (["CARGO", "CONSTRUCTION"].includes(code) && !["General Liability", "Commercial Package"].includes(newProduct) ) {
						newCoverageQuestionsStandAlone.push(foundCoverage);
					} else {
						newCoverageQuestions.push(foundCoverage);
					}
				}
			}
		}
		// Update state
		setProduct(newProduct);
		setCoverageQuestions(newCoverageQuestions);
		setCoverageQuestionsStandAlone(newCoverageQuestionsStandAlone);
		setCoverageQuestionsPackage(newCoveragePackages)
		// Update selected for stand-alone coverages
		setSelected((prev) => ({
			...prev,
			...Object.fromEntries(newCoverageQuestionsStandAlone.map((coverage) => [coverage.code, "Stand-alone"])),
			...Object.fromEntries(newCoveragePackages.map((coverage) => [coverage.code, "Package"])),
		}));
	}, [coverageToggles, setSelected]);

	const valueDict = {};

	return (
		<Container maxWidth={false} className={classes.contentGrid}>
			<Grid container spacing={3}>
				<Grid item xs={8}>
					<Grid container spacing={4}>
						<ApplicationHeader fontStyle={fontStyle} title={language[languagecode].new_app_bld} classes={classes} />
						<Grid item xs={11} className={classes.questionArea}>
							<span className={classes.subtitle}>{language[languagecode].last_q}</span>
							<p className={classes.description}></p>
							<div style={{ width: "100%", overflowY: "auto", maxHeight: "43vh" }}>
								{coverageQuestions.map((coverageToggle) => (
									<Box key={coverageToggle.code}>
										<CoverageToggle
											label={coverageToggle.name[languagecode]}
											selectedOption={selected[coverageToggle.code]}
											setSelectedOption={setSelected}
											code={coverageToggle.code}
											languagecode={languagecode}
										/>
									</Box>
								))}
								{false && coverageQuestionsStandAlone.map((coverageToggle) => (
									<Box key={coverageToggle.code}>
										<CoverageToggle
											label={coverageToggle.name["en"]}
											selectedOption={language[languagecode].stand_alone}
											setSelectedOption={() => {}}
											code={coverageToggle.code}
											disabled={true}
										/>
									</Box>
								))}
								{false && coverageQuestionsPackage.map((coverageToggle) => (
									<Box key={coverageToggle.code}>
										<CoverageToggle
											label={coverageToggle.name["en"]}
											selectedOption={language[languagecode].package}
											setSelectedOption={() => {}}
											code={coverageToggle.code}
											disabled={true}
										/>
									</Box>
								))}
							</div>
						</Grid>
						<Grid item xs={8}>
							<NavigationButtons
								onPrev={() => setStep((prevCount) => prevCount - 1)}
								onNext={() => {
									const create_opp_payload = {
										operations: [{ vertical: appDetails.industry, verticalid: appDetails.industry.id }],
										productcode: product,
										selectedverticalid: appDetails.industry.id,
										coverages: selected,
										appdetails: appDetails,
										customerid: appDetails?.customer?._id,
										prospectids: appDetails?.customer?.prospectids,
									};
									setPayload(create_opp_payload)
									if(insurers.length > 0) {
										setStep((prevCount) => prevCount + 1)
									}
									else{
										//start app
										setShowSpinner(true);
										dispatch(createProspectByCallingAPI(create_opp_payload));
									}
									// console.log(create_opp_payload)
									// console.log(appDetails)
									// console.log(selected)
								}}
								nextLabel={ insurers.length > 0 ? language[languagecode].next : language[languagecode].start_app}
								classes={classes}
								languagecode={languagecode}
								showSpinner={showSpinner}
							/>
						</Grid>
					</Grid>
				</Grid>
				<HelpSidebar
					title={valueDict[type]?.helptextTitle || ""}
					helpItems={valueDict?.[type]?.helptext || []}
					classes={classes}
				/>
			</Grid>
		</Container>
	);
};

const ReminderNavView = ({anchorEl, setAnchorEl, handleMenuClose}) => {
	const [showAddReminder, setshowAddReminder] = useState(false);
	const dispatch = useDispatch();
	const broker = useSelector(getBrokerInformation);
	return (
		<div className="nav-notification">		
			<>
				<div style={{ position: "relative", paddingRight: "1em" }}>
					<Badge
						badgeContent={broker.information?.unViewedReminderCount} // Number of notifications
						color="error" // Red badge
						overlap="circular"
						anchorOrigin={{
							vertical: "top",
							horizontal: "right",
						}}
					>
						<NotificationIcon style={{ fontSize: "1.3rem" }} />
					</Badge>
				</div>

				<AddCircleOutlineIcon
					// ref={buttonRef}
					onClick={(e) => {
						e.stopPropagation();
						handleMenuClose();
						//setAnchorEl(e.currentTarget);
						//setshowAddReminder(true)

						dispatch(reminderModalSet(true));
					}}
				/>
				<ReminderPopOver
					id="add-reminder-icon"
					setAnchorEl={setAnchorEl}
					anchorEl={anchorEl}
					setshowAddReminder={setshowAddReminder}
					showAddReminder={showAddReminder}
				/>
			</>
		</div>
	)
}

const HeaderNav = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
	const theme = createTheme();
	const broker = useSelector(getBrokerInformation);
	const languagecode = broker.information.languagepreference || "en";

	const useStyles = makeStyles((theme) => ({
		menu: {
			'& .MuiPaper-root': {
				border: '2px solid #d3d3d3',
				borderRadius: '12px',
				boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
				background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
				minWidth: '220px',
				padding: '8px 0',
			},
		},
		menuItem: {
			padding: '14px 20px',
			fontSize: '1rem',
			fontWeight: 500,
			color: '#2c3e50',
			borderBottom: '1px solid #f0f0f0',
			'&:last-child': {
				borderBottom: 'none',
			},
			'&:hover': {
				backgroundColor: '#e3f2fd',
				color: '#1976d2',
				transform: 'scale(1.02)',
				transition: 'all 0.3s ease-in-out',
			},
		},
		avatar: {
			width: 50, // Larger size
			height: 50,
			cursor: 'pointer',
  	},
	}));
	const classes = useStyles();
	const navItems = [
		{ label: 'Add new Prospect', path: '/add-prospect' },
		{ label: 'My Clients', path: '/mycustomers' },
		{ label: 'Dashboard', path: '/dashboard' },
		{ label: 'Feedback', path: '/feedback' },
		{ label: 'Help', path: '/howtoVideos' },
		{ label: 'Language', path: null },
		{ label: 'Reminders', path: '/reminders' },
		{ label: 'Settings', path: '/useradmin/user' },
		{ label: 'Quotey Admin', path: '/quoteyadmin/home' },
		{ label: 'Logout', path: '/logout' },
	];  
	
	const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (path) => {
    if(path){
			navigate(path);
			//handleMenuClose();
		}
  };

	const handleLangToggle = (event) => {
		const newLanguage = event.target.checked ? "fr" : "en";
		//setLanguage(newLanguage);
		// Save language in session storage
		sessionStorage.setItem("language", newLanguage);
		dispatch(updateUserLanguagePreference(newLanguage));
		if (broker?.information) {
			dispatch(updateBrokerLanguagePreference(newLanguage));

			// Update language preference in the store
			const langSelected = {
				label: newLanguage === "fr" ? "French" : "English",
				value: newLanguage,
			};

			dispatch(
				updateLanguagePreference({
					id: broker.information.user._id,
					languagePreference: langSelected,
				})
			);
			console.log("Language switched to", newLanguage);
		}
	};

	return (
		<ThemeProvider theme={theme}>
    <div className="Header" style={{ display: 'flex', justifyContent: 'space-between', margin: '12px 12px 2px 14px', paddingTop: "3vh" }}>
			{quoteyText ? (
				<img src={quoteyText} className="quotey-bot" alt="quoteyrobo" style={{'height':'6vh', width:"20vw", scale:"4.5"}} />
			) : (
				<div>Logo not found</div>
			)}
			<Badge
						badgeContent={broker.information?.unViewedReminderCount} // Number of notifications
						color="error" // Red badge
						overlap="circular"
						anchorOrigin={{
							vertical: "top",
							horizontal: "right",
						}}
					>
				<Avatar className={classes.avatar} alt="Remy Sharp" src="/static/images/avatar/1.jpg" onClick={handleAvatarClick} style={{ cursor: 'pointer' }}/>
			</Badge>
			<Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
				className={classes.menu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
				PaperProps={{
          style: {
            marginTop: '4vh', // Adds spacing below the avatar
          },
        }}
      >
        {navItems.map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => handleNavigation(item.path)}
						className={classes.menuItem}
          >
            {item.label} 
						{item.label == 'Reminders' &&  <ReminderNavView anchorEl={anchorEl} setAnchorEl={setAnchorEl} handleMenuClose={handleMenuClose} /> }
						{item.label == 'Language' &&  <Switch checked={languagecode == 'fr'} onChange={handleLangToggle}/> }
          </MenuItem>
        ))}
      </Menu>
		</div>
		</ThemeProvider>
	)
}

const InsurerSelection = ({ fontStyle, languagecode, setStep, step, type, appDetails, setAppDetails, payload, setShowSpinner, showSpinner }) => {
	const classes = useStyles();
	const [selected, setSelected] = useState({});
	const [ignoreInsurer, setignoreInsurer] = useState([])
	const dispatch = useDispatch();
	const [product, setProduct] = useState(null);
	const insurerList = useSelector(getInsurersList);
	let potentialSelectedVerticalid = null;
	if( appDetails.coverage.length > 0){
		let selectedCoverage = appDetails.coverage[0];
		potentialSelectedVerticalid = selectedCoverage.verticalid;
		if(appDetails.coverage.length > 1){
			// more than one, check if professional
			let profCvg = appDetails.coverage.find(x => x.code == "ProfessionalLiability")
			if(profCvg){
				selectedCoverage = profCvg;
			}
		}
		const allCoverageVerticalIds = appDetails.coverage.map(x => x.verticalid);
		let overRideVertical = selectedCoverage.otherinfo?.verticaloverride?.find(override => override.operations.includes(appDetails.industry.id));
		if(overRideVertical){
			potentialSelectedVerticalid = overRideVertical.overrideverticalid;
		}
		else if(potentialSelectedVerticalid == 0 || allCoverageVerticalIds.includes(0) ){
			potentialSelectedVerticalid = appDetails.industry.id;
		}
	}
	const insurers = potentialSelectedVerticalid ? insurerList.filter((x) => x.verticalids.includes(potentialSelectedVerticalid)).map(x => ({'name': x.name, 'imageUrl': x.s3image?.Location, 'code': x.code }) ) : [];
	//console.log(insurers)
	return (
		<Container maxWidth={false} className={classes.contentGrid}>
			<Grid container spacing={3}>
				<Grid item xs={8}>
					<Grid container spacing={4}>
						<ApplicationHeader fontStyle={fontStyle} title={language[languagecode].new_app_bld} classes={classes} />
						<Grid item xs={11} className={classes.questionArea}>
							<span className={classes.subtitle}>{language[languagecode].connected_i}</span>
							<div className={classes.description} style={{ width: "70%", overflowY: "auto"}} > {language[languagecode].connected_i_desc} </div>
						</Grid>
						<Grid item xs={8}>
							<NavigationButtons
								onPrev={() => {
									// if there is standalones to choose from go back 1 
									if(appDetails.sa_or_pkg){
										setStep((prevCount) => prevCount - 1)
									}
									else {
										setStep((prevCount) => prevCount - 2)
									}
									//otherwise go back 2
								}}
								onNext={() => {
									const payloadIns = {...payload, ignoreInsurer}
									console.log(payloadIns)
									setShowSpinner(true);
									// console.log(appDetails)
									// console.log(selected)
									dispatch(createProspectByCallingAPI(payloadIns));
								}}
								nextLabel={language[languagecode].start_app}
								classes={classes}
								languagecode={languagecode}
								showSpinner={showSpinner}
							/>
						</Grid>
					</Grid>
				</Grid>
				<InsurerHelpSideBar
					title={language[languagecode].connected_insurer}
					helpItems={insurers}
					classes={classes}
					ignoreInsurer={ignoreInsurer}
					setignoreInsurer={setignoreInsurer}
				/>
			</Grid>
		</Container>
	)
}

const GridButton = ({option, selected, type, languagecode, handleGridButtonClick  }) => {
	const isContained =
    type === 'coverage'
      ? Array.isArray(selected) && selected.some((item) => item.code === option.code)
      : selected?.code === option.code;
  const classes = useStyles({ isContained });
	return (
		<Button
      key={option.code}
      variant={isContained ? 'contained' : 'outlined'}
      color="primary"
      onClick={() => handleGridButtonClick(option)}
      className={classes.gridbutton}
    >
      <div style={{ fontWeight: 'bold', textAlign: 'center' }}>{option.name[languagecode]}</div>
      {/* <div style={{ color: '#666', fontSize: '0.75rem' }}>{option.description[languagecode]}</div> */}
    </Button>
	)
} 

const language = {
	'en': {
		'activity_snapshot': 'Activity Snapshot',
		'create_new_client': 'Create new client',
		'create_new_client_description': 'Start a new digital application from scratch',
		'create_new_client_btn': 'Add Prospect',
		'find_existing_client': 'Find existing client',
		'find_existing_client_desc': 'Go to a specific client dashboard',
		'find_existing_btn_text': 'Go',
		'nav_prev': 'BACK',
		'nav_next': 'NEXT',
		'new_app_bld': 'New application builder',
		'policy_q': 'What type of client are you quoting?',
		'policy_q_description': 'Is the policy for a business, an individual, or a farm?',
		'industry_q': 'What is the primary industry sector?',
		'industry_q_description': 'Select the main industry sector that this business belongs to. You can select specific operations later in the application.',
		'coverage_q': 'What coverages and products would you like included?',
		'coverage_q_description': 'Select one or more that should be included in the application. Make sure you select Property if there is any element of property coverage required including buildings, contents, equipment, or stock.',
		'last_q': 'Just a few last questions',
		'last_q_options_1': 'Are you looking to add',
		'last_q_options_2': 'to a package policy, or create an app for a standalone policy?',
		'start_app': "Start App",
		'connected_i': 'Connected Insurer',
		'connected_i_desc': 'On the right side of this screen, you will see a list of insurers who will be automatically connected to review this application when completed.\nYou can de-select insurers from your marketing of this particular application and they will not be connected',
		'view_sales_pipeline': 'View Sales Pipeline',
		'stand_alone': 'Stand-alone',
		'package': 'Package',
		'connected_insurer': 'Connected insurer',

	},
	'fr': {
		'activity_snapshot': 'Aperçu des activités',
		'create_new_client': 'Créer un nouveau client',
		'create_new_client_description': 'Démarrer une nouvelle demande numérique de zéro',
		'create_new_client_btn': 'Ajouter un client',
		'find_existing_client': 'Trouver un client existant',
		'find_existing_client_desc': 'Accéder au dossier d\'un client spécifique',
		'find_existing_btn_text': 'Aller',
		'nav_prev': 'PRÉCÉDENT',
		'nav_next': 'SUIVANT',
		'new_app_bld': 'Nouvel outil de création de demande',
		'policy_q': 'Quel type de police proposez-vous ?',
		'policy_q_description': 'La police est-elle destinée à une entreprise, un particulier ou une ferme ?',
		'industry_q': 'Quel est le secteur industriel principal ?',
		'industry_q_description': 'Sélectionnez le secteur industriel principal auquel cette entreprise appartient. Vous pourrez sélectionner des opérations spécifiques plus tard dans la demande.',
		'coverage_q': 'Quelles couvertures souhaitez-vous inclure ?',
		'coverage_q_description': 'Sélectionnez une ou plusieurs couvertures à inclure dans la demande. Assurez-vous de sélectionner la couverture des biens si un élément de couverture des biens est requis, y compris les bâtiments, le contenu, l’équipement ou le stock.',
		'last_q': 'Juste quelques dernières questions',
		'last_q_options_1': 'Cherchez-vous à ajouter',
		'last_q_options_2': 'à une police combinée, ou à créer une demande pour une police autonome ?',
		'start_app': "Démarrer l'application",
		'start_RFQ': "Démarrer l'appel d'offres",
		'connected_i': 'Assureurs connectés',
		'connected_i_desc': 'Sur le côté droit de cet écran, vous verrez une liste d\'assureurs qui seront automatiquement connectés pour examiner cette demande une fois terminée.\nVous pouvez désélectionner des assureurs de votre marketing pour cette demande particulière et ils ne seront pas connectés',
		'view_sales_pipeline': 'Voir le pipeline de ventes',
		'stand_alone': 'Autonome',
		'package': 'Forfait',
		'connected_insurer': 'Assureur connecté',
	}
}

export default HomePage;